<template>
<div>
  <ul class="list-inline">
    <li>
      <v-btn icon @click.stop="$router.push('/')">
        <i class="fas fa-home"></i>
      </v-btn>
    </li>
    <li v-for="item in breadcrumb" :key="item.path">
      <template v-if="item.move">
        <v-btn text @click.stop="move(item)">{{ item.name }}</v-btn>
      </template>
      <template v-else>
        <v-btn text>{{ item.name }}</v-btn>
      </template>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    breadcrumb() {
      const map = []
      for (const view of this.items) {
        switch (view.name) {
          case '受注管理':
          case '支払管理':
          case '報告書管理':
          case '商品管理':
          case '予約管理':
          case 'データ管理':
          case '設定':
            view.move = false
            break
          default:
            view.move = true
        }
        map.push(view)
      }

      return map
    },
  },
  methods: {
    move(item) {
      const index = this.breadcrumb.findIndex(e => e.name == item.name)
      if (this.breadcrumb.length - 1 > index) {
        this.$router.push(item.path)
      }
    },
  },
}
</script>

<style lang='scss' scoped>
ul {
  font-size: 14px;
  li {
    position: relative;
    padding-right: 15px;
    vertical-align: top;
    line-height: 36px;
    i {
      font-size: 16px;
    }
    &:after {
      position: absolute;
      right: 0;
      top: 2px;
      content: "\f105";
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
    }
    &:last-of-type {
      margin-right: 0;
      padding-right: 0;
      &:after {
        content: "";
      }
    }
  }
}
</style>
